import { get } from '@/services/fetch'

/// 获取签名信息
export const getJsApiTicket = (url) => get('/api/v1/getJsApiTicket', url)
